// Discards a draft. The row is gone from every read afterwards, so its cached
// detail is dropped and the lists (and their counts) refresh.
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { discardListingRequestDraft } from './listingRequestEndpoints'
import { listingRequestKeys } from './listingRequestQueryKeys'

export function useDiscardListingRequestDraftMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => discardListingRequestDraft(id),
    onSuccess: (_result, id) => {
      queryClient.removeQueries({ queryKey: listingRequestKeys.detail(id) })
      queryClient.invalidateQueries({ queryKey: listingRequestKeys.lists() })
    },
  })
}
